import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Auth/Login';
import Inicio from '@/components/Inicio';
import MisClasesPage from '@/features/clases/MisClasesPage';
import MisTutoriasPage from '@/features/tutorias/MisTutoriasPage';
import RegistroAcademico from '@/components/RegistroAcademico';
import RegistroEvaluaciones from '@/components/RegistroEvaluaciones';
import ApoyoEstudiantil from '@/components/ApoyoEstudiantil';


import ProgramarClasePage from '@/features/clases/ProgramarClasePage';
import ProgramarTutoriaPage from '@/features/tutorias/ProgramarTutoriaPage';
import Profile from '@/components/Profile';
import ActualizacionForm from '@/components/Auth/ActualizacionForm';
import Notificaciones from '@/components/Notificaciones/Banners';
import AvanzarNivelPage from '@/features/nivel/AvanzarNivelPage';
import SolicitarCertificadoPage from '@/features/nivel/SolicitarCertificadoPage';
import FinalizarNivelPage from '@/features/nivel/FinalizarNivelPage';
import NotFound from '@/components/NotFound';
import EncuestaSatisfaccionPage from '@/features/encuestas/EncuestaSatisfaccionPage';

import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/index.html',
      name: 'home_index',
      component: Inicio,
      meta: { Auth: true, title: 'Mis Clases' },
    },
    {
      path: '/',
      name: 'home',
      component: Inicio,
      meta: { Auth: true, title: 'Mis Clases' },
    },
    {
      path: '/mis-clases',
      name: 'mis_clases',
      component: MisClasesPage,
      meta: { Auth: true, title: 'Mis Clases' },
    },
    {
      path: '/encuesta/:id',
      name: 'encuesta_satisfaccion',
      component: EncuestaSatisfaccionPage,
      // Updating: se puede responder aunque falte actualizar datos (evita un ciclo de redirecciones)
      meta: { Auth: true, title: 'Encuesta de Satisfacción', Updating: true },
    },
    {
      path: '/mis-tutorias',
      name: 'mis_tutorias',
      component: MisTutoriasPage,
      meta: { Auth: true, title: 'Mis Tutorias' },
    },
    {
      path: '/programar',
      name: 'programar',
      component: ProgramarClasePage,
      meta: { Auth: true, title: 'Programar' },
    },
    {
      path: '/tutoria',
      name: 'tutoria',
      component: ProgramarTutoriaPage,
      meta: { Auth: true, title: 'Tutoria' },
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: { Auth: true, title: 'Perfil'},
    },
    {
      path: '/registro-academico',
      name: 'registro_academico',
      component: RegistroAcademico,
      meta: { Auth: true, title: 'Registro Academico'},
    },
    {
      path: '/evaluaciones',
      name: 'evaluaciones',
      component: RegistroEvaluaciones,
      meta: { Auth: true, title: 'Evaluaciones'},
    },
    {
      path: '/apoyo-estudiantil',
      name: 'apoyo_estudiantil',
      component: ApoyoEstudiantil,
      meta: { Auth: true, title: 'Apoyo Estudiantil'},
    },
    {
      path: '/actualizar_datos',
      name: 'actualizar_datos',
      component: ActualizacionForm,
      meta: { Auth: true, title: 'Perfil', Updating : true },
    },
    {
      path: '/notificaciones',
      name: 'notificaciones',
      component: Notificaciones,
      meta: { Auth: true, title: 'Notificaciones', Updating : true },
    },
    {
      path: '/finalizar-nivel',
      name: 'finalizar-nivel',
      component: FinalizarNivelPage,
      meta: { Auth: true, title: 'Finalizar Nivel', Updating : true },
    },
    {
      path: '/avanzar-nivel',
      name: 'avanzar-nivel',
      component: AvanzarNivelPage,
      meta: { Auth: true, title: 'Avance de Nivel', Updating : true },
    },
    {
      path: '/certificado',
      name: 'certificado',
      component: SolicitarCertificadoPage,
      meta: { Auth: true, title: 'Certificado', Updating : true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { Auth: false, title: 'Programador de Clases de American School Way' },
      beforeEnter: (to, from, next) => {
        if(store.state.auth.logged) {
          next({ path: '/' });
        } else {
          next();
        }
      }
    },
    {
      path: '*',
      name: 'not_found',
      component: NotFound,
      meta: { Auth: false, title: 'Página no encontrada - 404' }
    }
  ]
})


//.configurar el router
//para cada cambio de ruta

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title;
  if (to.meta.Auth && !store.state.auth.logged) {
    next({path: '/login'});
  }else {
    if (store.state.auth.logged) {
      store.commit('auth/setUser');
    }

    // Encuesta de satisfacción obligatoria: cubre navegación interna y el botón atrás.
    // Solo aplica a rutas con sesión; /login no pasa por aquí, así que cerrar sesión nunca se bloquea.
    // Si la consulta falla, fetchObligatoria devuelve null y se permite navegar.
    if (store.state.auth.logged && to.meta.Auth) {
      const obligatoria = await store.dispatch('encuestaSatisfaccion/fetchObligatoria');
      if (obligatoria) {
        const esLaEncuesta = to.name === 'encuesta_satisfaccion' && String(to.params.id) === String(obligatoria.id);
        if (esLaEncuesta) {
          next();
        } else {
          next({ name: 'encuesta_satisfaccion', params: { id: obligatoria.id }, replace: true });
        }
        return;
      }
    }

    if (store.state.auth.logged && store.state.auth.user.data.debe_actualizar && !to.meta.Updating) {
      next({path: '/actualizar_datos'});
    }else{
      next();
    }

  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  
  // Refrescar notificaciones si el usuario está logueado
  /* if (store.state.auth.logged) {
    store.dispatch('notificaciones/fetchNotificaciones', { page: 1, perPage: 10 }).catch(error => {
      
    });
  } */
});

//.para cada cambio de ruta


export default router;